import "./client.58890414.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired767"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired767"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $9KNE7 = parcelRequire("9KNE7");


var $7YFi7 = parcelRequire("7YFi7");

var $iauuA = parcelRequire("iauuA");
const $a671aae1b743611c$export$62651879628e0c4c = (body)=>{
    return (0, $iauuA.$axios).post('/messages', body);
};



const $05724efce6b7845c$export$d5d8fc50aded1148 = ()=>{
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState('');
    const [submitted, setSubmitted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const formik = (0, $7YFi7.useFormik)({
        initialValues: {
            name: '',
            phone: '',
            message: ''
        },
        onSubmit: async (values)=>{
            try {
                await (0, $a671aae1b743611c$export$62651879628e0c4c)(values);
                (0, $9KNE7.toast).success('Thank you! We will be in touch soon.', {
                    autoClose: 10000
                });
                setSubmitted(true);
            } catch (err) {
                setError(err.message || err.response.data || 'An error occurred. Please try again later.');
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9KNE7.ToastContainer), {
                position: "top-center"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: "/assets/logo.png",
                alt: "Outpost Builders"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: "Let's Talk!"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container",
                children: [
                    !submitted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "Send Message"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                                onSubmit: formik.handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        placeholder: "Name",
                                        value: formik.values.name,
                                        onChange: formik.handleChange,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "tel",
                                        name: "phone",
                                        placeholder: "Phone Number",
                                        value: formik.values.phone,
                                        onChange: formik.handleChange,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                                        name: "message",
                                        placeholder: "Enter your message",
                                        value: formik.values.message,
                                        onChange: formik.handleChange,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "submit",
                                        disabled: formik.isSubmitting,
                                        children: "Send Message"
                                    }),
                                    error.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "error",
                                        children: error
                                    })
                                ]
                            })
                        ]
                    }),
                    submitted && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "Thank You!"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: "We will be in touch soon."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                children: "Reach Us"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "tel:9107774995",
                                title: "Call or Text Us",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "(910) 777-4995"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "mailto:outpostdesignbuild@gmail.com",
                                title: "Email Us",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "outpostdesignbuild@gmail.com"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kDekv = parcelRequire("kDekv");

const $b68dccf4f51c833a$export$144901db2ea8e967 = ()=>{
    const [photos, setPhotos] = (0, $acw62.useState)([]);
    const [carouselInterval, setCarouselInterval] = (0, $acw62.useState)(null);
    const [currentPhotoIndex, setCurrentPhotoIndex] = (0, $acw62.useState)(0);
    const [isPaused, setIsPaused] = (0, $acw62.useState)(false);
    const currentlySelectedPhoto = photos[currentPhotoIndex] ?? {
        title: 'No photo',
        url: '/assets/no-image.png'
    };
    (0, $acw62.useEffect)(()=>{
        const fetchPhotos = async ()=>{
            try {
                const response = await (0, $kDekv.getPhotos)();
                setPhotos(response.data);
            } catch (err) {
                console.error('Failed to get outpost builders photos', err);
            }
        };
        fetchPhotos();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (carouselInterval) clearInterval(carouselInterval);
        if (isPaused) return;
        setCarouselInterval(setInterval(()=>{
            setCurrentPhotoIndex((prevIndex)=>{
                const nextIndex = prevIndex + 1;
                return nextIndex >= photos.length ? 0 : nextIndex;
            });
        }, 3000));
    }, [
        isPaused,
        photos
    ]);
    const onSelectPhoto = (0, $acw62.useCallback)((index)=>{
        setCurrentPhotoIndex(index);
        setIsPaused(true);
    }, []);
    const imageStyle = (0, $acw62.useMemo)(()=>{
        return {
            backgroundImage: `url(${photos[currentPhotoIndex]?.url})`
        };
    }, [
        photos,
        currentPhotoIndex
    ]);
    const goBack = (0, $acw62.useCallback)(()=>{
        setCurrentPhotoIndex((prevIndex)=>{
            const nextIndex = prevIndex - 1;
            return nextIndex < 0 ? photos.length - 1 : nextIndex;
        });
        setIsPaused(true);
    }, [
        photos
    ]);
    const goNext = (0, $acw62.useCallback)(()=>{
        setCurrentPhotoIndex((prevIndex)=>{
            const nextIndex = prevIndex + 1;
            return nextIndex >= photos.length ? 0 : nextIndex;
        });
        setIsPaused(true);
    }, [
        photos
    ]);
    const createThumbnailStyle = (0, $acw62.useCallback)((url)=>{
        return {
            backgroundImage: `url(${url})`
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                children: "Why Outpost?"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                children: "One Word... Quality."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "image-container",
                "aria-label": currentlySelectedPhoto.title,
                style: imageStyle,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "title-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: goBack,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "50",
                                height: "50",
                                viewBox: "0 0 50 50",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M39.5834 7.25005L39.5834 44.7501C39.5822 45.1297 39.4775 45.5019 39.2806 45.8265C39.0836 46.151 38.8018 46.4158 38.4656 46.5921C38.1294 46.7685 37.7514 46.8498 37.3724 46.8274C36.9934 46.8049 36.6277 46.6795 36.3147 46.4646L9.23135 27.7146C8.10843 26.9376 8.10843 25.0667 9.23135 24.2876L36.3147 5.53755C36.6271 5.32052 36.9929 5.19325 37.3726 5.16957C37.7522 5.14588 38.1311 5.22669 38.468 5.40321C38.805 5.57973 39.0871 5.84521 39.2837 6.17081C39.4804 6.49641 39.584 6.86968 39.5834 7.25005Z",
                                        fill: "white",
                                        fillOpacity: "0.3"
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            children: currentlySelectedPhoto.title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            onClick: goNext,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                                width: "50",
                                height: "50",
                                viewBox: "0 0 50 50",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                                        d: "M10.4166 7.25005L10.4166 44.7501C10.4178 45.1297 10.5225 45.5019 10.7194 45.8265C10.9164 46.151 11.1982 46.4158 11.5344 46.5921C11.8706 46.7685 12.2486 46.8498 12.6276 46.8274C13.0066 46.8049 13.3723 46.6795 13.6853 46.4646L40.7687 27.7146C41.8916 26.9376 41.8916 25.0667 40.7687 24.2876L13.6853 5.53755C13.3729 5.32052 13.0071 5.19325 12.6274 5.16957C12.2478 5.14588 11.8689 5.22669 11.532 5.40321C11.195 5.57973 10.9129 5.84521 10.7163 6.17081C10.5196 6.49641 10.416 6.86968 10.4166 7.25005Z",
                                        fill: "white",
                                        fillOpacity: "0.3"
                                    }),
                                    " "
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "image-nav",
                children: [
                    photos.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Sorry, no photos to show right now."
                    }),
                    photos.map((photo, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: index === currentPhotoIndex ? 'selected' : '',
                            onClick: ()=>onSelectPhoto(index),
                            style: createThumbnailStyle(photo.url)
                        }, photo.url))
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $efJg5 = parcelRequire("efJg5");

const $196243b858a7896e$export$b37e8a4e6768b00c = ()=>{
    const [testimonials, setTestimonials] = (0, $acw62.useState)([]);
    const [scrollDirection, setScrollDirection] = (0, $acw62.useState)('down');
    const [isHovering, setIsHovering] = (0, $acw62.useState)(false);
    const [isInView, setIsInView] = (0, $acw62.useState)(false);
    const scrollContainerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        (0, $efJg5.getTestimonials)().then((res)=>{
            setTestimonials(res.data);
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setIsInView(entry.isIntersecting);
            });
        }, {
            threshold: 0.1
        } // Adjust this value as needed
        );
        if (scrollContainerRef.current) observer.observe(scrollContainerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollStep = 1 // Adjust this value for faster or slower scrolling
        ;
        const scrollInterval = 10 // Adjust this value for faster or slower scrolling
        ;
        const scroll = ()=>{
            if (isHovering || !isInView) return;
            if (scrollDirection === 'down') {
                if (scrollContainer.scrollTop < scrollContainer.scrollHeight - scrollContainer.clientHeight - 2) scrollContainer.scrollTop += scrollStep;
                else setScrollDirection('up');
            } else if (scrollContainer.scrollTop > 0) scrollContainer.scrollTop -= scrollStep;
            else setScrollDirection('down');
        };
        const intervalId = setInterval(scroll, scrollInterval);
        return ()=>clearInterval(intervalId);
    }, [
        scrollDirection,
        isHovering
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "col-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    children: "Our Satisfied Customers"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "col-testimonials",
                ref: scrollContainerRef,
                onMouseEnter: ()=>setIsHovering(true),
                onMouseLeave: ()=>setIsHovering(false),
                children: testimonials.map((testimonial)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "testimonial",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: `"${testimonial.quote}"`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                children: testimonial.name
                            })
                        ]
                    }, testimonial.quote))
            })
        ]
    });
};


const $fbe96dab6134d228$var$automaticNavBarScrollAction = ()=>{
    const nav = document.querySelector('nav');
    if (!nav) throw new Error('Failed to find nav bar elements');
    if (window.innerWidth < 768) return;
    const scrollPointToCloseNav = 400;
    if (window.scrollY > scrollPointToCloseNav) nav.classList.remove('opened');
    else nav.classList.add('opened');
};
const $fbe96dab6134d228$export$cb698ebc8168f00 = ()=>{
    const openNavButton = document.querySelector('nav .open');
    const closeNavButton = document.querySelector('nav .close');
    const navLinkItems = document.querySelectorAll('nav .content > a');
    const nav = document.querySelector('nav');
    if (!nav || !openNavButton || !closeNavButton || !navLinkItems.length) throw new Error('Failed to find nav bar elements');
    if (window.innerWidth > 768) nav.classList.add('opened');
    for(let i = 0; i < navLinkItems.length; i++)navLinkItems[i].addEventListener('click', function() {
        nav.classList.remove('opened');
        window.removeEventListener('scroll', $fbe96dab6134d228$var$automaticNavBarScrollAction);
    });
    window.addEventListener('scroll', $fbe96dab6134d228$var$automaticNavBarScrollAction);
    openNavButton.addEventListener('click', ()=>{
        nav.classList.add('opened');
        window.removeEventListener('scroll', $fbe96dab6134d228$var$automaticNavBarScrollAction);
    });
    closeNavButton.addEventListener('click', ()=>{
        nav.classList.remove('opened');
        window.removeEventListener('scroll', $fbe96dab6134d228$var$automaticNavBarScrollAction);
    });
};


const $5a283b6fa3b36b50$var$setupSection = (id, component)=>{
    const node = document.getElementById(id);
    if (!node) throw Error(`No #${id} in document.`);
    const root = (0, $aRPiL.createRoot)(node);
    root.render(component);
};
$5a283b6fa3b36b50$var$setupSection('carousel', /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b68dccf4f51c833a$export$144901db2ea8e967), {}));
$5a283b6fa3b36b50$var$setupSection('contact', /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05724efce6b7845c$export$d5d8fc50aded1148), {}));
$5a283b6fa3b36b50$var$setupSection('testimonials', /*#__PURE__*/ (0, $ayMG0.jsx)((0, $196243b858a7896e$export$b37e8a4e6768b00c), {}));
(0, $fbe96dab6134d228$export$cb698ebc8168f00)();


//# sourceMappingURL=client.3f8c19e0.js.map
